// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button[loading].mat-button.loading-button,
button[loading-raised].mat-button.loading-button {
   cursor: default;
}

button[loading].mat-raised-button.mat-primary,
button[loading-raised].mat-raised-button.mat-primary {
   transition: background-color 0.4s;
}

button[loading].mat-raised-button.mat-primary.loading-button,
button[loading-raised].mat-raised-button.mat-primary.loading-button {
   background-color: rgba(0, 178, 201, 0.3);
   cursor: default;
}

button[loading].mat-raised-button:not(.mat-primary).loading-button .mat-button-wrapper,
button[loading-raised].mat-raised-button:not(.mat-primary).loading-button .mat-button-wrapper {
   color: rgba(85, 85, 85, 0.5);
}

button[loading].mat-button.loading-button .mat-button-wrapper,
button[loading-raised].mat-button.loading-button .mat-button-wrapper {
   color: rgba(0, 178, 201, 0.3);
}

button[loading] .loading-spinner,
button[loading-raised] .loading-spinner {
   position: absolute;
   left: 50%;
   top: 50%;
   margin-left: -10px;
   margin-top: -10px;
}


button[loading].mat-button,
button[loading-raised].mat-button,
button[loading].mat-raised-button,
button[loading-raised].mat-raised-button {
   box-sizing: border-box;
   position: relative;
   -webkit-user-select: none;
   user-select: none;
   cursor: pointer;
   outline: 0;
   border: none;
   -webkit-tap-highlight-color: transparent;
   display: inline-block;
   white-space: nowrap;
   text-decoration: none;
   vertical-align: baseline;
   text-align: center;
   margin: 0;
   min-width: 88px;
   line-height: 30px;
   padding: 0 16px;
   border-radius: 20px;
   height: 30px;
}

button[loading].mat-fab,
button[loading-raised].mat-fab,
button[loading].mat-icon-button,
button[loading-raised].mat-icon-button,
button[loading].mat-mini-fab,
button[loading-raised].mat-mini-fab {
   box-sizing: border-box;
   position: relative;
   -webkit-user-select: none;
   user-select: none;
   cursor: pointer;
   outline: 0;
   border: none;
   -webkit-tap-highlight-color: transparent;
   display: inline-block;
   white-space: nowrap;
   text-decoration: none;
   vertical-align: baseline;
   text-align: center;
   margin: 0;
   min-width: 88px;
   line-height: 36px;
   padding: 0 16px;
   border-radius: 2px;
}

button[loading][disabled].mat-button,
button[loading-raised][disabled].mat-button,
button[loading][disabled].mat-fab,
button[loading-raised][disabled].mat-fab,
button[loading][disabled].mat-icon-button,
button[loading-raised][disabled].mat-icon-button,
button[loading][disabled].mat-mini-fab,
button[loading-raised][disabled].mat-mini-fab,
button[loading][disabled].mat-raised-button,
button[loading-raised][disabled].mat-raised-button {
   cursor: default;
}

button[loading].cdk-keyboard-focused.mat-button .mat-button-focus-overlay,
button[loading-raised].cdk-keyboard-focused.mat-button .mat-button-focus-overlay,
button[loading].cdk-keyboard-focused.mat-fab .mat-button-focus-overlay,
button[loading-raised].cdk-keyboard-focused.mat-fab .mat-button-focus-overlay,
button[loading].cdk-keyboard-focused.mat-icon-button .mat-button-focus-overlay,
button[loading-raised].cdk-keyboard-focused.mat-icon-button .mat-button-focus-overlay,
button[loading].cdk-keyboard-focused.mat-mini-fab .mat-button-focus-overlay,
button[loading-raised].cdk-keyboard-focused.mat-mini-fab .mat-button-focus-overlay,
button[loading].cdk-keyboard-focused.mat-raised-button .mat-button-focus-overlay,
button[loading-raised].cdk-keyboard-focused.mat-raised-button .mat-button-focus-overlay,
button[loading].cdk-program-focused.mat-button .mat-button-focus-overlay,
button[loading-raised].cdk-program-focused.mat-button .mat-button-focus-overlay,
button[loading].cdk-program-focused.mat-fab .mat-button-focus-overlay,
button[loading-raised].cdk-program-focused.mat-fab .mat-button-focus-overlay,
button[loading].cdk-program-focused.mat-icon-button .mat-button-focus-overlay,
button[loading-raised].cdk-program-focused.mat-icon-button .mat-button-focus-overlay,
button[loading].cdk-program-focused.mat-mini-fab .mat-button-focus-overlay,
button[loading-raised].cdk-program-focused.mat-mini-fab .mat-button-focus-overlay,
button[loading].cdk-program-focused.mat-raised-button .mat-button-focus-overlay,
button[loading-raised].cdk-program-focused.mat-raised-button .mat-button-focus-overlay {
   opacity: 1;
}

button[loading].mat-button::-moz-focus-inner,
button[loading-raised].mat-button::-moz-focus-inner,
button[loading].mat-fab::-moz-focus-inner,
button[loading-raised].mat-fab::-moz-focus-inner,
button[loading].mat-icon-button::-moz-focus-inner,
button[loading-raised].mat-icon-button::-moz-focus-inner,
button[loading].mat-mini-fab::-moz-focus-inner,
button[loading-raised].mat-mini-fab::-moz-focus-inner,
button[loading].mat-raised-button::-moz-focus-inner,
button[loading-raised].mat-raised-button::-moz-focus-inner {
   border: 0;
}

button[loading].mat-fab,
button[loading-raised].mat-fab,
button[loading].mat-mini-fab,
button[loading-raised].mat-mini-fab,
button[loading].mat-raised-button,
button[loading-raised].mat-raised-button {
   transform: translate3d(0, 0, 0);
   transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}

button[loading].mat-fab:not([class*="mat-elevation-z"]),
button[loading-raised].mat-fab:not([class*="mat-elevation-z"]),
button[loading].mat-mini-fab:not([class*="mat-elevation-z"]),
button[loading-raised].mat-mini-fab:not([class*="mat-elevation-z"]),
button[loading].mat-raised-button:not([class*="mat-elevation-z"]),
button[loading-raised].mat-raised-button:not([class*="mat-elevation-z"]) {
   box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

button[loading].mat-fab:not([disabled]):active:not([class*="mat-elevation-z"]),
button[loading-raised].mat-fab:not([disabled]):active:not([class*="mat-elevation-z"]),
button[loading].mat-mini-fab:not([disabled]):active:not([class*="mat-elevation-z"]),
button[loading-raised].mat-mini-fab:not([disabled]):active:not([class*="mat-elevation-z"]),
button[loading].mat-raised-button:not([disabled]):active:not([class*="mat-elevation-z"]),
button[loading-raised].mat-raised-button:not([disabled]):active:not([class*="mat-elevation-z"]) {
   box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

button[loading][disabled].mat-fab,
button[loading-raised][disabled].mat-fab,
button[loading][disabled].mat-mini-fab,
button[loading-raised][disabled].mat-mini-fab,
button[loading][disabled].mat-raised-button,
button[loading-raised][disabled].mat-raised-button {
   box-shadow: none;
}

button[loading].mat-button .mat-button-focus-overlay,
button[loading-raised].mat-button .mat-button-focus-overlay,
button[loading].mat-icon-button .mat-button-focus-overlay,
button[loading-raised].mat-icon-button .mat-button-focus-overlay {
   transition: none;
   opacity: 0;
}

button[loading].mat-button:hover .mat-button-focus-overlay,
button[loading-raised].mat-button:hover .mat-button-focus-overlay {
   opacity: 1;
}

button[loading].mat-fab,
button[loading-raised].mat-fab {
   min-width: 0;
   border-radius: 50%;
   width: 56px;
   height: 56px;
   padding: 0;
   flex-shrink: 0;
}

button[loading].mat-fab:not([class*="mat-elevation-z"]),
button[loading-raised].mat-fab:not([class*="mat-elevation-z"]) {
   box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
}

button[loading].mat-fab:not([disabled]):active:not([class*="mat-elevation-z"]),
button[loading-raised].mat-fab:not([disabled]):active:not([class*="mat-elevation-z"]) {
   box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 12px 17px 2px rgba(0, 0, 0, 0.14),
      0 5px 22px 4px rgba(0, 0, 0, 0.12);
}

button[loading].mat-fab .mat-button-wrapper,
button[loading-raised].mat-fab .mat-button-wrapper {
   padding: 16px 0;
   display: inline-block;
   line-height: 24px;
}

button[loading].mat-mini-fab,
button[loading-raised].mat-mini-fab {
   min-width: 0;
   border-radius: 50%;
   width: 40px;
   height: 40px;
   padding: 0;
   flex-shrink: 0;
}

button[loading].mat-mini-fab:not([class*="mat-elevation-z"]),
button[loading-raised].mat-mini-fab:not([class*="mat-elevation-z"]) {
   box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
}

button[loading].mat-mini-fab:not([disabled]):active:not([class*="mat-elevation-z"]),
button[loading-raised].mat-mini-fab:not([disabled]):active:not([class*="mat-elevation-z"]) {
   box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 12px 17px 2px rgba(0, 0, 0, 0.14),
      0 5px 22px 4px rgba(0, 0, 0, 0.12);
}

button[loading].mat-mini-fab .mat-button-wrapper,
button[loading-raised].mat-mini-fab .mat-button-wrapper {
   padding: 8px 0;
   display: inline-block;
   line-height: 24px;
}

button[loading].mat-icon-button,
button[loading-raised].mat-icon-button {
   padding: 0;
   min-width: 0;
   width: 40px;
   height: 40px;
   flex-shrink: 0;
   line-height: 40px;
   border-radius: 50%;
}

button[loading].mat-icon-button .mat-icon,
button[loading-raised].mat-icon-button .mat-icon,
button[loading].mat-icon-button i,
button[loading-raised].mat-icon-button i {
   line-height: 24px;
}

button[loading].mat-button,
button[loading-raised].mat-button,
button[loading].mat-fab,
button[loading-raised].mat-fab,
button[loading].mat-icon-button,
button[loading-raised].mat-icon-button,
button[loading].mat-mini-fab,
button[loading-raised].mat-mini-fab,
button[loading].mat-raised-button,
button[loading-raised].mat-raised-button {
   /* TODO(mdc-migration): After Material v17, try changing color back to 'color: currentColor' */
   /* Currently at Material v16, theme is buggy. It disrespect our theme & contrast color in zdox-theme.scss */
   /* color: currentColor; */
}

button[loading].mat-button .mat-button-wrapper > *,
button[loading-raised].mat-button .mat-button-wrapper > *,
button[loading].mat-fab .mat-button-wrapper > *,
button[loading-raised].mat-fab .mat-button-wrapper > *,
button[loading].mat-icon-button .mat-button-wrapper > *,
button[loading-raised].mat-icon-button .mat-button-wrapper > *,
button[loading].mat-mini-fab .mat-button-wrapper > *,
button[loading-raised].mat-mini-fab .mat-button-wrapper > *,
button[loading].mat-raised-button .mat-button-wrapper > *,
button[loading-raised].mat-raised-button .mat-button-wrapper > * {
   vertical-align: middle;
}

button[loading] .mat-button-focus-overlay,
button[loading-raised] .mat-button-focus-overlay,
button[loading] .mat-button-ripple,
button[loading-raised] .mat-button-ripple {
   top: 0;
   left: 0;
   right: 0;
   bottom: 0;
   position: absolute;
   pointer-events: none;
}

button[loading] .mat-button-focus-overlay,
button[loading-raised] .mat-button-focus-overlay {
   background-color: rgba(0, 0, 0, 0.12);
   border-radius: inherit;
   opacity: 0;
   transition: opacity 0.2s cubic-bezier(0.35, 0, 0.25, 1), background-color 0.2s cubic-bezier(0.35, 0, 0.25, 1);
}

@media screen and (-ms-high-contrast: active) {
   button[loading] .mat-button-focus-overlay,
   button[loading-raised] .mat-button-focus-overlay {
      background-color: rgba(255, 255, 255, 0.5);
   }
}

button[loading] .mat-button-ripple-round,
button[loading-raised] .mat-button-ripple-round {
   border-radius: 50%;
   z-index: 1;
}

@media screen and (-ms-high-contrast: active) {
   button[loading].mat-button,
   button[loading-raised].mat-button,
   button[loading].mat-fab,
   button[loading-raised].mat-fab,
   button[loading].mat-icon-button,
   button[loading-raised].mat-icon-button,
   button[loading].mat-mini-fab,
   button[loading-raised].mat-mini-fab,
   button[loading].mat-raised-button,
   button[loading-raised].mat-raised-button {
      outline: solid 1px;
   }
}

button[loading].loading-button:not([disabled]):active:not([class*="mat-elevation-z"]),
button[loading-raised].loading-button:not([disabled]):active:not([class*="mat-elevation-z"]) {
   box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/loading-button/button.css"],"names":[],"mappings":"AAAA;;GAEG,eAAe;AAClB;;AAEA;;GAEG,iCAAiC;AACpC;;AAEA;;GAEG,wCAAwC;GACxC,eAAe;AAClB;;AAEA;;GAEG,4BAA4B;AAC/B;;AAEA;;GAEG,6BAA6B;AAChC;;AAEA;;GAEG,kBAAkB;GAClB,SAAS;GACT,QAAQ;GACR,kBAAkB;GAClB,iBAAiB;AACpB;;;AAGA;;;;GAIG,sBAAsB;GACtB,kBAAkB;GAClB,yBAAyB;GAGzB,iBAAiB;GACjB,eAAe;GACf,UAAU;GACV,YAAY;GACZ,wCAAwC;GACxC,qBAAqB;GACrB,mBAAmB;GACnB,qBAAqB;GACrB,wBAAwB;GACxB,kBAAkB;GAClB,SAAS;GACT,eAAe;GACf,iBAAiB;GACjB,eAAe;GACf,mBAAmB;GACnB,YAAY;AACf;;AAEA;;;;;;GAMG,sBAAsB;GACtB,kBAAkB;GAClB,yBAAyB;GAGzB,iBAAiB;GACjB,eAAe;GACf,UAAU;GACV,YAAY;GACZ,wCAAwC;GACxC,qBAAqB;GACrB,mBAAmB;GACnB,qBAAqB;GACrB,wBAAwB;GACxB,kBAAkB;GAClB,SAAS;GACT,eAAe;GACf,iBAAiB;GACjB,eAAe;GACf,kBAAkB;AACrB;;AAEA;;;;;;;;;;GAUG,eAAe;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;GAoBG,UAAU;AACb;;AAEA;;;;;;;;;;GAUG,SAAS;AACZ;;AAEA;;;;;;GAMG,+BAA+B;GAC/B,2GAA2G;AAC9G;;AAEA;;;;;;GAMG,+GAA+G;AAClH;;AAEA;;;;;;GAMG,qHAAqH;AACxH;;AAEA;;;;;;GAMG,gBAAgB;AACnB;;AAEA;;;;GAIG,gBAAgB;GAChB,UAAU;AACb;;AAEA;;GAEG,UAAU;AACb;;AAEA;;GAEG,YAAY;GACZ,kBAAkB;GAClB,WAAW;GACX,YAAY;GACZ,UAAU;GACV,cAAc;AACjB;;AAEA;;GAEG,iHAAiH;AACpH;;AAEA;;GAEG;wCACqC;AACxC;;AAEA;;GAEG,eAAe;GACf,qBAAqB;GACrB,iBAAiB;AACpB;;AAEA;;GAEG,YAAY;GACZ,kBAAkB;GAClB,WAAW;GACX,YAAY;GACZ,UAAU;GACV,cAAc;AACjB;;AAEA;;GAEG,iHAAiH;AACpH;;AAEA;;GAEG;wCACqC;AACxC;;AAEA;;GAEG,cAAc;GACd,qBAAqB;GACrB,iBAAiB;AACpB;;AAEA;;GAEG,UAAU;GACV,YAAY;GACZ,WAAW;GACX,YAAY;GACZ,cAAc;GACd,iBAAiB;GACjB,kBAAkB;AACrB;;AAEA;;;;GAIG,iBAAiB;AACpB;;AAEA;;;;;;;;;;GAUG,8FAA8F;GAC9F,2GAA2G;GAC3G,yBAAyB;AAC5B;;AAEA;;;;;;;;;;GAUG,sBAAsB;AACzB;;AAEA;;;;GAIG,MAAM;GACN,OAAO;GACP,QAAQ;GACR,SAAS;GACT,kBAAkB;GAClB,oBAAoB;AACvB;;AAEA;;GAEG,qCAAqC;GACrC,sBAAsB;GACtB,UAAU;GACV,6GAA6G;AAChH;;AAEA;GACG;;MAEG,0CAA0C;GAC7C;AACH;;AAEA;;GAEG,kBAAkB;GAClB,UAAU;AACb;;AAEA;GACG;;;;;;;;;;MAUG,kBAAkB;GACrB;AACH;;AAEA;;GAEG,+GAA+G;AAClH","sourcesContent":["button[loading].mat-button.loading-button,\nbutton[loading-raised].mat-button.loading-button {\n   cursor: default;\n}\n\nbutton[loading].mat-raised-button.mat-primary,\nbutton[loading-raised].mat-raised-button.mat-primary {\n   transition: background-color 0.4s;\n}\n\nbutton[loading].mat-raised-button.mat-primary.loading-button,\nbutton[loading-raised].mat-raised-button.mat-primary.loading-button {\n   background-color: rgba(0, 178, 201, 0.3);\n   cursor: default;\n}\n\nbutton[loading].mat-raised-button:not(.mat-primary).loading-button .mat-button-wrapper,\nbutton[loading-raised].mat-raised-button:not(.mat-primary).loading-button .mat-button-wrapper {\n   color: rgba(85, 85, 85, 0.5);\n}\n\nbutton[loading].mat-button.loading-button .mat-button-wrapper,\nbutton[loading-raised].mat-button.loading-button .mat-button-wrapper {\n   color: rgba(0, 178, 201, 0.3);\n}\n\nbutton[loading] .loading-spinner,\nbutton[loading-raised] .loading-spinner {\n   position: absolute;\n   left: 50%;\n   top: 50%;\n   margin-left: -10px;\n   margin-top: -10px;\n}\n\n\nbutton[loading].mat-button,\nbutton[loading-raised].mat-button,\nbutton[loading].mat-raised-button,\nbutton[loading-raised].mat-raised-button {\n   box-sizing: border-box;\n   position: relative;\n   -webkit-user-select: none;\n   -moz-user-select: none;\n   -ms-user-select: none;\n   user-select: none;\n   cursor: pointer;\n   outline: 0;\n   border: none;\n   -webkit-tap-highlight-color: transparent;\n   display: inline-block;\n   white-space: nowrap;\n   text-decoration: none;\n   vertical-align: baseline;\n   text-align: center;\n   margin: 0;\n   min-width: 88px;\n   line-height: 30px;\n   padding: 0 16px;\n   border-radius: 20px;\n   height: 30px;\n}\n\nbutton[loading].mat-fab,\nbutton[loading-raised].mat-fab,\nbutton[loading].mat-icon-button,\nbutton[loading-raised].mat-icon-button,\nbutton[loading].mat-mini-fab,\nbutton[loading-raised].mat-mini-fab {\n   box-sizing: border-box;\n   position: relative;\n   -webkit-user-select: none;\n   -moz-user-select: none;\n   -ms-user-select: none;\n   user-select: none;\n   cursor: pointer;\n   outline: 0;\n   border: none;\n   -webkit-tap-highlight-color: transparent;\n   display: inline-block;\n   white-space: nowrap;\n   text-decoration: none;\n   vertical-align: baseline;\n   text-align: center;\n   margin: 0;\n   min-width: 88px;\n   line-height: 36px;\n   padding: 0 16px;\n   border-radius: 2px;\n}\n\nbutton[loading][disabled].mat-button,\nbutton[loading-raised][disabled].mat-button,\nbutton[loading][disabled].mat-fab,\nbutton[loading-raised][disabled].mat-fab,\nbutton[loading][disabled].mat-icon-button,\nbutton[loading-raised][disabled].mat-icon-button,\nbutton[loading][disabled].mat-mini-fab,\nbutton[loading-raised][disabled].mat-mini-fab,\nbutton[loading][disabled].mat-raised-button,\nbutton[loading-raised][disabled].mat-raised-button {\n   cursor: default;\n}\n\nbutton[loading].cdk-keyboard-focused.mat-button .mat-button-focus-overlay,\nbutton[loading-raised].cdk-keyboard-focused.mat-button .mat-button-focus-overlay,\nbutton[loading].cdk-keyboard-focused.mat-fab .mat-button-focus-overlay,\nbutton[loading-raised].cdk-keyboard-focused.mat-fab .mat-button-focus-overlay,\nbutton[loading].cdk-keyboard-focused.mat-icon-button .mat-button-focus-overlay,\nbutton[loading-raised].cdk-keyboard-focused.mat-icon-button .mat-button-focus-overlay,\nbutton[loading].cdk-keyboard-focused.mat-mini-fab .mat-button-focus-overlay,\nbutton[loading-raised].cdk-keyboard-focused.mat-mini-fab .mat-button-focus-overlay,\nbutton[loading].cdk-keyboard-focused.mat-raised-button .mat-button-focus-overlay,\nbutton[loading-raised].cdk-keyboard-focused.mat-raised-button .mat-button-focus-overlay,\nbutton[loading].cdk-program-focused.mat-button .mat-button-focus-overlay,\nbutton[loading-raised].cdk-program-focused.mat-button .mat-button-focus-overlay,\nbutton[loading].cdk-program-focused.mat-fab .mat-button-focus-overlay,\nbutton[loading-raised].cdk-program-focused.mat-fab .mat-button-focus-overlay,\nbutton[loading].cdk-program-focused.mat-icon-button .mat-button-focus-overlay,\nbutton[loading-raised].cdk-program-focused.mat-icon-button .mat-button-focus-overlay,\nbutton[loading].cdk-program-focused.mat-mini-fab .mat-button-focus-overlay,\nbutton[loading-raised].cdk-program-focused.mat-mini-fab .mat-button-focus-overlay,\nbutton[loading].cdk-program-focused.mat-raised-button .mat-button-focus-overlay,\nbutton[loading-raised].cdk-program-focused.mat-raised-button .mat-button-focus-overlay {\n   opacity: 1;\n}\n\nbutton[loading].mat-button::-moz-focus-inner,\nbutton[loading-raised].mat-button::-moz-focus-inner,\nbutton[loading].mat-fab::-moz-focus-inner,\nbutton[loading-raised].mat-fab::-moz-focus-inner,\nbutton[loading].mat-icon-button::-moz-focus-inner,\nbutton[loading-raised].mat-icon-button::-moz-focus-inner,\nbutton[loading].mat-mini-fab::-moz-focus-inner,\nbutton[loading-raised].mat-mini-fab::-moz-focus-inner,\nbutton[loading].mat-raised-button::-moz-focus-inner,\nbutton[loading-raised].mat-raised-button::-moz-focus-inner {\n   border: 0;\n}\n\nbutton[loading].mat-fab,\nbutton[loading-raised].mat-fab,\nbutton[loading].mat-mini-fab,\nbutton[loading-raised].mat-mini-fab,\nbutton[loading].mat-raised-button,\nbutton[loading-raised].mat-raised-button {\n   transform: translate3d(0, 0, 0);\n   transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\nbutton[loading].mat-fab:not([class*=\"mat-elevation-z\"]),\nbutton[loading-raised].mat-fab:not([class*=\"mat-elevation-z\"]),\nbutton[loading].mat-mini-fab:not([class*=\"mat-elevation-z\"]),\nbutton[loading-raised].mat-mini-fab:not([class*=\"mat-elevation-z\"]),\nbutton[loading].mat-raised-button:not([class*=\"mat-elevation-z\"]),\nbutton[loading-raised].mat-raised-button:not([class*=\"mat-elevation-z\"]) {\n   box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n}\n\nbutton[loading].mat-fab:not([disabled]):active:not([class*=\"mat-elevation-z\"]),\nbutton[loading-raised].mat-fab:not([disabled]):active:not([class*=\"mat-elevation-z\"]),\nbutton[loading].mat-mini-fab:not([disabled]):active:not([class*=\"mat-elevation-z\"]),\nbutton[loading-raised].mat-mini-fab:not([disabled]):active:not([class*=\"mat-elevation-z\"]),\nbutton[loading].mat-raised-button:not([disabled]):active:not([class*=\"mat-elevation-z\"]),\nbutton[loading-raised].mat-raised-button:not([disabled]):active:not([class*=\"mat-elevation-z\"]) {\n   box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);\n}\n\nbutton[loading][disabled].mat-fab,\nbutton[loading-raised][disabled].mat-fab,\nbutton[loading][disabled].mat-mini-fab,\nbutton[loading-raised][disabled].mat-mini-fab,\nbutton[loading][disabled].mat-raised-button,\nbutton[loading-raised][disabled].mat-raised-button {\n   box-shadow: none;\n}\n\nbutton[loading].mat-button .mat-button-focus-overlay,\nbutton[loading-raised].mat-button .mat-button-focus-overlay,\nbutton[loading].mat-icon-button .mat-button-focus-overlay,\nbutton[loading-raised].mat-icon-button .mat-button-focus-overlay {\n   transition: none;\n   opacity: 0;\n}\n\nbutton[loading].mat-button:hover .mat-button-focus-overlay,\nbutton[loading-raised].mat-button:hover .mat-button-focus-overlay {\n   opacity: 1;\n}\n\nbutton[loading].mat-fab,\nbutton[loading-raised].mat-fab {\n   min-width: 0;\n   border-radius: 50%;\n   width: 56px;\n   height: 56px;\n   padding: 0;\n   flex-shrink: 0;\n}\n\nbutton[loading].mat-fab:not([class*=\"mat-elevation-z\"]),\nbutton[loading-raised].mat-fab:not([class*=\"mat-elevation-z\"]) {\n   box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);\n}\n\nbutton[loading].mat-fab:not([disabled]):active:not([class*=\"mat-elevation-z\"]),\nbutton[loading-raised].mat-fab:not([disabled]):active:not([class*=\"mat-elevation-z\"]) {\n   box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 12px 17px 2px rgba(0, 0, 0, 0.14),\n      0 5px 22px 4px rgba(0, 0, 0, 0.12);\n}\n\nbutton[loading].mat-fab .mat-button-wrapper,\nbutton[loading-raised].mat-fab .mat-button-wrapper {\n   padding: 16px 0;\n   display: inline-block;\n   line-height: 24px;\n}\n\nbutton[loading].mat-mini-fab,\nbutton[loading-raised].mat-mini-fab {\n   min-width: 0;\n   border-radius: 50%;\n   width: 40px;\n   height: 40px;\n   padding: 0;\n   flex-shrink: 0;\n}\n\nbutton[loading].mat-mini-fab:not([class*=\"mat-elevation-z\"]),\nbutton[loading-raised].mat-mini-fab:not([class*=\"mat-elevation-z\"]) {\n   box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);\n}\n\nbutton[loading].mat-mini-fab:not([disabled]):active:not([class*=\"mat-elevation-z\"]),\nbutton[loading-raised].mat-mini-fab:not([disabled]):active:not([class*=\"mat-elevation-z\"]) {\n   box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 12px 17px 2px rgba(0, 0, 0, 0.14),\n      0 5px 22px 4px rgba(0, 0, 0, 0.12);\n}\n\nbutton[loading].mat-mini-fab .mat-button-wrapper,\nbutton[loading-raised].mat-mini-fab .mat-button-wrapper {\n   padding: 8px 0;\n   display: inline-block;\n   line-height: 24px;\n}\n\nbutton[loading].mat-icon-button,\nbutton[loading-raised].mat-icon-button {\n   padding: 0;\n   min-width: 0;\n   width: 40px;\n   height: 40px;\n   flex-shrink: 0;\n   line-height: 40px;\n   border-radius: 50%;\n}\n\nbutton[loading].mat-icon-button .mat-icon,\nbutton[loading-raised].mat-icon-button .mat-icon,\nbutton[loading].mat-icon-button i,\nbutton[loading-raised].mat-icon-button i {\n   line-height: 24px;\n}\n\nbutton[loading].mat-button,\nbutton[loading-raised].mat-button,\nbutton[loading].mat-fab,\nbutton[loading-raised].mat-fab,\nbutton[loading].mat-icon-button,\nbutton[loading-raised].mat-icon-button,\nbutton[loading].mat-mini-fab,\nbutton[loading-raised].mat-mini-fab,\nbutton[loading].mat-raised-button,\nbutton[loading-raised].mat-raised-button {\n   /* TODO(mdc-migration): After Material v17, try changing color back to 'color: currentColor' */\n   /* Currently at Material v16, theme is buggy. It disrespect our theme & contrast color in zdox-theme.scss */\n   /* color: currentColor; */\n}\n\nbutton[loading].mat-button .mat-button-wrapper > *,\nbutton[loading-raised].mat-button .mat-button-wrapper > *,\nbutton[loading].mat-fab .mat-button-wrapper > *,\nbutton[loading-raised].mat-fab .mat-button-wrapper > *,\nbutton[loading].mat-icon-button .mat-button-wrapper > *,\nbutton[loading-raised].mat-icon-button .mat-button-wrapper > *,\nbutton[loading].mat-mini-fab .mat-button-wrapper > *,\nbutton[loading-raised].mat-mini-fab .mat-button-wrapper > *,\nbutton[loading].mat-raised-button .mat-button-wrapper > *,\nbutton[loading-raised].mat-raised-button .mat-button-wrapper > * {\n   vertical-align: middle;\n}\n\nbutton[loading] .mat-button-focus-overlay,\nbutton[loading-raised] .mat-button-focus-overlay,\nbutton[loading] .mat-button-ripple,\nbutton[loading-raised] .mat-button-ripple {\n   top: 0;\n   left: 0;\n   right: 0;\n   bottom: 0;\n   position: absolute;\n   pointer-events: none;\n}\n\nbutton[loading] .mat-button-focus-overlay,\nbutton[loading-raised] .mat-button-focus-overlay {\n   background-color: rgba(0, 0, 0, 0.12);\n   border-radius: inherit;\n   opacity: 0;\n   transition: opacity 0.2s cubic-bezier(0.35, 0, 0.25, 1), background-color 0.2s cubic-bezier(0.35, 0, 0.25, 1);\n}\n\n@media screen and (-ms-high-contrast: active) {\n   button[loading] .mat-button-focus-overlay,\n   button[loading-raised] .mat-button-focus-overlay {\n      background-color: rgba(255, 255, 255, 0.5);\n   }\n}\n\nbutton[loading] .mat-button-ripple-round,\nbutton[loading-raised] .mat-button-ripple-round {\n   border-radius: 50%;\n   z-index: 1;\n}\n\n@media screen and (-ms-high-contrast: active) {\n   button[loading].mat-button,\n   button[loading-raised].mat-button,\n   button[loading].mat-fab,\n   button[loading-raised].mat-fab,\n   button[loading].mat-icon-button,\n   button[loading-raised].mat-icon-button,\n   button[loading].mat-mini-fab,\n   button[loading-raised].mat-mini-fab,\n   button[loading].mat-raised-button,\n   button[loading-raised].mat-raised-button {\n      outline: solid 1px;\n   }\n}\n\nbutton[loading].loading-button:not([disabled]):active:not([class*=\"mat-elevation-z\"]),\nbutton[loading-raised].loading-button:not([disabled]):active:not([class*=\"mat-elevation-z\"]) {\n   box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
